import { checkUrlStatus } from "@/requests/libraries/check-url-status.request";
import { useQuery } from "@tanstack/react-query";

export const useCheckUrlStatus = (url: string) => {
  return useQuery({
    queryKey: ["url-status", url],
    queryFn: () => checkUrlStatus(url),
    enabled: !!url,
    retry: false,
  });
};
